<template>
  <div>
    <b-form-radio-group
      v-model="selected"
      stacked
      name="dialog-radio-buttons"
      v-if="!noSelectable"
    >
      <div
        :key="index"
        v-for="(option, index) in paymentMethods"
        class="mb-2 bg-white rounded p-3 font-weight-bold"
        style="font-size:13px"
      >
        <b-form-radio :key="index" :value="option">
          <div class="d-flex justify-content-between align-items-center">
            <b-row
              class="d-flex justify-content-between gap-2 align-items-center w-100"
            >
              <b-col cols="1" style="margin-left:15px">
                <img
                  :src="getImgUrl(option.cardType)"
                  width="30"
                  :title="option.cardType"
                />
              </b-col>
              <b-col cols="4" class="ml-2">
                **** **** **** {{ option.lastFour }}
              </b-col>
              <b-col cols="2" class="ml-1">
                {{ option.expDate.slice(0, 2) }}/{{ option.expDate.slice(2) }}
              </b-col>
              <b-col>
                {{ option.comments ? `(${option.comments})` : "" }}
              </b-col>
            </b-row>
            <div class="ml-4">
              <b-link
                @click="removeCard(option.id)"
                class="text-danger text-nowrap font-weight-bold"
              >
                <img
                  class="b-action-item ml-2 mr-1"
                  height="15"
                  :src="imageDelete"
                />
              </b-link>
            </div>
          </div>
        </b-form-radio>
      </div>
    </b-form-radio-group>
    <div v-else>
      <div
        :key="index"
        v-for="(option, index) in paymentMethods"
        class="mb-2 bg-white rounded p-3 font-weight-bold card-item"
        style="font-size: 13px"
      >
        <div class="d-flex justify-content-between align-items-center w-100">
          <b-row
            class="d-flex justify-content-between gap-2 align-items-center w-100"
          >
            <b-col cols="1" style="margin-left: 15px">
              <img
                :src="getImgUrl(option.cardType)"
                width="30"
                :title="option.cardType"
              />
            </b-col>
            <b-col cols="4" class="ml-2">
              **** **** **** {{ option.lastFour }}
            </b-col>
            <b-col cols="2" class="ml-1">
              {{ option.expDate?.slice(0, 2) }}/{{ option.expDate?.slice(2) }}
            </b-col>
            <b-col>
              {{ option.comments ? `(${option.comments})` : "" }}
            </b-col>
          </b-row>
          <div class="ml-3">
            <b-link
              @click="removeCard(option.id, index)"
              class="text-danger text-nowrap font-weight-bold"
            >
              Remove
            </b-link>
          </div>
        </div>
      </div>
    </div>
    <b-link
      v-if="!isDemographics"
      style="font-size:13px"
      @click="isNewCardVisible = true"
    >
      Add new card
    </b-link>
    <patient-payment-method-add-modal
      v-if="isNewCardVisible"
      v-model="isNewCardVisible"
      :patientId="patientId"
      @onModify="getAllPaymentMethods"
      :forDemographics="isDemographics"
      @setPaymentInfo="setPatientPaymentMethods"
    />
  </div>
</template>

<script>
import paymentMethodsServer from "../../server/paymentMethod";
import PatientPaymentMethodAddModal from "./PatientPaymentMethodAddModal.vue";

export default {
  name: "PatientPaymentMethods",
  components: { PatientPaymentMethodAddModal },
  props: ["patientId", "value", "noSelectable", "isDemographics"],
  data() {
    return {
      paymentMethods: [],
      isNewCardVisible: false
    };
  },
  async mounted() {
    this.getAllPaymentMethods();
  },
  methods: {
    async removeCard(id, index) {
      if (!this.isDemographics) {
        await paymentMethodsServer.delete(id);
        this.getAllPaymentMethods();
      } else {
        this.$dialog
          .confirm(
            {
              title: "Are you sure you want to remove this payment method?"
            },
            {
              view: "confirm-delete"
            }
          )
          .then(() => {
            this.paymentMethods.splice(index, 1);
            this.$emit("setPatientPaymentMethods");
          });
      }
    },
    async getAllPaymentMethods(id) {
      if (this.patientId) {
        this.paymentMethods = await paymentMethodsServer.query(this.patientId);
        this.isNewCardVisible = false;
      }
      if (id) {
        this.paymentMethods = await paymentMethodsServer.query(id);
      }
      if (this.paymentMethods.length > 0) {
        this.selected = this.paymentMethods[0].ccInfoKey;
      }
    },
    getImgUrl(pic) {
      let fileName = "";
      try {
        fileName = require("../../assets/cards/" +
          pic.toLowerCase().trim() +
          ".png");
      } catch (e) {
        fileName = require("../../assets/cards/default_card.png");
      }
      return fileName;
    },
    setPatientPaymentMethods(data) {
      this.paymentMethods.push({
        ...data,
        expDate: data.expMonth + data.expYear.slice(-2),
        lastFour: data.cardNumber.slice(-4)
      });
      this.$emit("setPatientPaymentMethods");
    }
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    },
    imageDelete() {
      return this.isStandalone()
        ? "/icons/delete.svg"
        : "/desktop/icons/delete.svg";
    }
  }
};
</script>

<style scoped>
.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 63px;
  padding: 1rem;
  margin-top: 15px;
  margin-bottom: 15px;
}

.custom-control-label {
  width: 100%;
}

.card-item {
  background-color: #f5f8fc !important;
  border-radius: 15px !important;
  box-shadow: 5px 5px 5px -5px rgba(0, 0, 0, 0.5) !important;
}
</style>
